import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PackageMasterApi } from '../api/packagemaster.api';
import {
  PackageMasterData,
  PackageMaster,
  PackageMasterPayload
} from '../../../interfaces/masters/packagemaster';

@Injectable()
export class PackageMasterService extends PackageMasterData {

  constructor(private api: PackageMasterApi) {
    super();
  }

  list(url: string): Observable<PackageMaster[]> {
    return this.api.list(url);
  }

  getById(url: string): Observable<PackageMaster> {
    return this.api.getById(url);
  }

  create(url: string, data: PackageMasterPayload): Observable<any> {
    return this.api.add(url, data);
  }

  update(url: string, data: PackageMasterPayload): Observable<any> {
    return this.api.update(url, data);
  }

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }

}